import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import Slider from "react-slick";
import Axios from "axios";
import { Accordion, Card, Button } from "react-bootstrap";
import MySchedule from "./MySchedule";
import MessageModal from "./modals/MessageModal";
import HelpDeskModal from "./modals/HelpDeskModal";
import firebase from "../../Firebase/index";
import "../../registerSW";
const Lobby = () => {
  const [sponserImg, setSponserImg] = useState([]);
  const [slideToShowImgCount, setSlideToShowImgCount] = useState(1);
  const [myScheduleModal, setMyScheduleModal] = useState(false);
  const [helpDeskModal, setHelpDeskModal] = useState(false);
  const [helpDeskContents, setHelpDeskContents] = useState([]);
  const [messageModal, setMessageModal] = useState(false);
  const [userMessages, setUserMessages] = useState([]);
  const [localAttraction, setLocalAttraction] = useState(null);
  const [allowAsExhibitor, setAllowAsExhibitor] = useState(false);
  const [allowAsSpeaker, setAllowAsSpeaker] = useState(false);
  const [allowAttendee, setAllowAttendee] = useState(false);
  const { id } = useParams();
  const eventId = localStorage.getItem("eventId");

  useEffect(() => {
    getSliderData();
    getLocalAttraction();
    var rolesArr = localStorage.getItem("currentRole").split(",");
    if (rolesArr.indexOf("-1") !== -1) {
      setAllowAsExhibitor(true);
    }
    if (rolesArr.indexOf("-6") !== -1) {
      setAllowAsSpeaker(true);
    }
    if (rolesArr.indexOf("111") !== -1) {
      setAllowAttendee(true);
    }
  }, []);

  useEffect(() => {
    if (helpDeskModal) getHelpDeskData();
    if (messageModal) getEventMessages();
    // return () => {
    //   setHelpDeskContents([])
    // }
  }, [helpDeskModal, messageModal]);

  useEffect(() => {
    if (/iPhone|iPad|Mac|Macintosh|iPod/i.test(navigator.userAgent)) {
      console.log("yes apple");
    } else {
      if (!("Notification" in window)) {
        console.log("This browser does not support desktop notification");
      } else if (Notification.permission === "granted") {
        const messaging = firebase.messaging();
        messaging
          .getToken()
          .then((token) => {
            saveFirebasePushNotificationToken(token);
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(function (permission) {
          if (permission === "granted") {
            const messaging = firebase.messaging();
            messaging
              .getToken()
              .then((token) => {
                const tokData = {
                  token: token,
                  email: localStorage.getItem("username"),
                };

                Axios.post(
                  `${global.config.requestUrl}saveFirebaseToken`,
                  tokData,
                  {
                    headers: {
                      "auth-token": localStorage.getItem("exhibitorToken"),
                    },
                  }
                )
                  .then((res) => {})
                  .catch((err) => {
                    console.log(err);
                  });
              })
              .catch((err) => {
                console.log(err);
              });
          }
        });
      }
    }
  }, []);

  const saveFirebasePushNotificationToken = (token) => {
    const tokData = {
      token: token,
      email: localStorage.getItem("username"),
    };

    Axios.post(`${global.config.requestUrl}saveFirebaseToken`, tokData, {
      headers: { "auth-token": localStorage.getItem("exhibitorToken") },
    })
      .then((res) => {})
      .catch((err) => {
        console.log(err);
      });
  };

  //Get slider images data
  const getSliderData = () => {
    Axios.get(
      `${global.config.requestUrl}exhibitor?eventId=${eventId}&type=1`
    ).then((res) => {
      if (res.data.errorCode === 0) {
        setSponserImg(res.data.data);
        if (res.data.data.length > 1) setSlideToShowImgCount(2);
      } else {
        setSponserImg([
          {
            logo: process.env.PUBLIC_URL + "/images/sponser-dummy.png",
            exhibitor_id: null,
          },
        ]);
      }
    });
  };

  //Get Information data
  const getHelpDeskData = () => {
    Axios.get(
      `${global.config.requestUrl}user/getHelpDeskContent?eventId=${eventId}`,
      { headers: { "auth-token": localStorage.exhibitorToken } }
    )

      .then((res) => {
        if (!res.data.errorCode) setHelpDeskContents(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
//Get Event Messages data
  const getEventMessages = () => {
    Axios.get(
      `${global.config.requestUrl}user/getEventMessages?eventId=${eventId}`,
      {
        headers: { "auth-token": localStorage.exhibitorToken },
      }
    )
      .then((res) => {
        if (res.data.errorCode === 0) setUserMessages(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getLocalAttraction = () => {
    Axios.get(
      `${global.config.requestUrl}getLocalAttraction?eventId=${eventId}`,
      {
        headers: { "auth-token": localStorage.exhibitorToken },
      }
    )
      .then((res) => {
        if (res.data.errorCode === 0) setLocalAttraction(res.data.data[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //Handle My Schedule modal
  const myScheduleModalHandler = (e) => {
    e.preventDefault();
    setMyScheduleModal(!myScheduleModal);
  };

  //Handle Information modal
  const helpDeskModalHandler = (e) => {
    e.preventDefault();
    setHelpDeskModal(!helpDeskModal);
  };

  //Handle Event Messages Modal
  const messageModalHandler = (e) => {
    e.preventDefault();
    setMessageModal(!messageModal);
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: slideToShowImgCount,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
    vertical: false,
  };
  return (
    <React.Fragment>
  
       <div className="px-3 pt-0">
        <div className="card pt0-aroundnot-important border-none" style={{ paddingTop: 0 }}>
          <div className="centeralign">
           <Link
              to="/mshc2026/conference"
              className="mt-1">
              <img
                  src="/images/mshc2026/event_schedule.png"
                  alt="Event Schedule"
                  className="menuImg1 btnIcon mt-1"
                />
            </Link>
            </div>
          <div className="threeSideList">
            <Link
              to="/"
              onClick={myScheduleModalHandler}
              className="mt-1 halfBtn"
            >
              <img
                  src="/images/mshc2026/myschedule.png"
                  alt="My Schedule"
                  className="menuImg btnIcon "
                />
            </Link>

             <Link
              to="/mshc2026/sponsors"
              className="btnIcon mt-1 halfBtn"
            >
              <img
                  src="/images/mshc2026/sponsors.png"
                  alt="sponsers"
                  className="menuImg btnIcon"
                />
            </Link>


           <Link
              to="/mshc2026/speakers"
              className="btnIcon mt-1 halfBtn"
            >
              <img
                  src="/images/mshc2026/speakers.png"
                  alt="Speakers"
                  className="menuImg btnIcon"
                />
            </Link>

             <a
              rel="noopener noreferrer"
              className="btnIcon mt-1 halfBtn"
              href={"https://minnesotasafetycouncil.org/common/Uploaded%20files/MNSC%20Website/Conference/MysticLake-Map.pdf"}
              target="_blank"
            >
                <img
                  src="/images/mshc2026/eventfloormap.png"
                  alt="Event Floor Map"
                  className="menuImg btnIcon"
                />
            </a> 

             <a
              rel="noopener noreferrer"
              className="btnIcon mt-1 halfBtn"
              href={"https://minnesotasafetycouncil.org/MNSC/Conference/Interactive-Booth-Map.aspx"}
              target="_blank"
            >
                <img
                  src="/images/mshc2026/vendorhallmap.png"
                  alt="Vendor Hall Map"
                  className="menuImg btnIcon"
                
                />
            </a> 

               <Link
               to="/mshc2026/attendee/exhibitHall"
              className="btnIcon mt-1 halfBtn"
            >
                <img
                  src="/images/mshc2026/vendordetails.png"
                  alt="Exhibitor Deatails"
                  className="menuImg btnIcon"
                 
                />
            </Link> 

             <a
              rel="noopener noreferrer"
              className="btnIcon mt-1 halfBtn"
              href={"https://minnesotasafetycouncil.org/MNSC/Governor-s-Safety-Award/2025-Governor-s-Safety-Award-Winners.aspx"}
              target="_blank"
            >
                <img
                  src="/images/mshc2026/safetyawards.png"
                  alt="Safety Awards"
                  className="menuImg btnIcon"
                
                />
            </a> 

             <a
              rel="noopener noreferrer"
              className="btnIcon mt-1 halfBtn"
              href={"https://gwsa.mnsc.org/t/cp2bKbQ9Kgus"}
              target="_blank"
            >
                <img
                  src="/images/mshc2026/sessionsurvey.png"
                  alt="Session Survey"
                  className="menuImg btnIcon"
                 
                />
            </a> 

             <a
              rel="noopener noreferrer"
              className="btnIcon mt-1 halfBtn"
              href={"https://gwsa.mnsc.org/t/rPNgCuEiL1us"}
              target="_blank"
            >
                <img
                  src="/images/mshc2026/ceuform.png"
                  alt="Ceu Forrm"
                  className="menuImg btnIcon"
               
                />
            </a> 

              <a
              rel="noopener noreferrer"
               target="_blank"
              className="btnIcon mt-1 halfBtn"
              href={"https://minnesotasafetycouncil.org/common/Uploaded%20files/MNSC%20Website/Conference/2026%20Conference/2026_MNConf_Program.pdf"}
             
            >
                <img
                  src="/images/mshc2026/finalprogram.png"
                  alt="Final Program"
                  className="menuImg btnIcon"
               
                />
            </a> 

              <Link
                         to="/"
                         onClick={messageModalHandler}
                         className="btnIcon mt-1 halfBtn"
                       >
                <img
                  src="/images/mshc2026/eventmessages.png"
                  alt="Event Messages"
                  className="menuImg btnIcon"
                 
                />
            </Link>
                <a
                href={"https://minnesotasafetycouncil.org/common/Uploaded%20files/MNSC%20Website/Conference/2026%20Conference/Attendee_FAQ2026_letter.pdf"}
                className="btnIcon mt-1 halfBtn"
                rel="noopener noreferrer"
               target="_blank"
            >
                <img
                  src="/images/mshc2026/faq.png"
                  alt="Faq"
                  className="menuImg btnIcon"
               
                />
            </a>
          </div>
              <div className="logoRow">
  <div className="border-logo">
      <a
              rel="noopener noreferrer"
              className="btnIcon mt-1 halfBtn"
              href={"https://www.huntelec.com/"}
              target="_blank"
            >
  <img
    src={`${process.env.PUBLIC_URL}/images/mshc2026/Hunt-Electric-logo.png`}
    alt="Hunt Electric"
  />
  </a>
  <a
              rel="noopener noreferrer"
              className="btnIcon mt-1 halfBtn"
              href={"https://www.minnesotasafetycouncil.org/"}
              target="_blank"
            >
   <img
    src={`${process.env.PUBLIC_URL}/images/mshc2026/black-nsc.png`}
    alt="NSC Logo"
  />
  </a>
</div>
</div>
        </div>
        {myScheduleModal ? (
          <div className="midModal">
            {/* <div className="modalOverlay" onClick={myScheduleModalHandler}></div> */}
            <div className="midContentWrp">
              <div
                className="modalPopUpClose"
                id="myschedulepopup"
                onClick={myScheduleModalHandler}
              >
                <i className="fa fa-times"></i>
              </div>
              <MySchedule />
            </div>
          </div>
        ) : null}
        {helpDeskModal ? (
          <HelpDeskModal
            closeModal={helpDeskModalHandler}
            helpDeskContents={helpDeskContents}
          />
        ) : null}
        {messageModal ? (
          <MessageModal
            closeModal={messageModalHandler}
            userMessages={userMessages}
          />
        ) : null}

        {/* <div className="border-none mt-3">
          <div className="threeSideList">
            {sponserImg.map((sponsor, index) => (
              <div className="card" key={index}>
                {sponsor.link ? (
                  <a href={sponsor.link} target="_blank">
                    <img src={sponsor.logo} alt="" />
                  </a>
                ) : (
                  <img src={sponsor.logo} alt="" />
                )}
              </div>
            ))}
          </div>
        </div> */}


      </div>
    </React.Fragment>
  );
};
export default Lobby;
